/* eslint-disable */


import SupervisorDashService from "@/services/SupervisorDashService";
import { defineStore } from "pinia";
import moment from "moment";
import { toast } from "vue3-toastify";

export const useSupervisorDashboardStore = defineStore("supervisorDashboardStore", {

  state: () => ({


    groupTalkPosts: [],

    groupTalkPost: {},
    supervisorToGroupTalkPost: {},

    post: {},

    thisVideoIsYoutube: false,

    source1: "",
    doesPDFNameExistInLibrary: "",

    optionsArray: [

      { id: 1, name: 'Checkoff', type: 'checkoff', desc: 'Simply uncheck employees not in attendance' },
      { id: 2, name: 'Collect signatures', type: 'signature', desc: 'Select workers in attendance and pass around device to collect signatures' },
      { id: 3, name: 'Take photo of sign-in sheet', type: 'signed_sheet', desc: 'You can take a photo of the physical sign-in sheet' },

    ],

    showSignOffModalOption: false,

    currentMethodSelected: '',

    showCheckoffEmployeeModal: false,

    employees: [],
    employeesCheck: [],

    employeeData: {
      employeesCheck: [],
      time_acknowledged: ''
    },

    updateEmployeesCheck: [],

    showUpdateCheckoffModal: false,

    showEmployeesListToSelectSignaturesModal: false,

    employeesToCollectSignatures: [],
    employeesSelectedForSignatures: [],

    showListOfEmployeesToCollectSignauresFrom: false,

    showSignatureBoxModal: false,

    currentEmployeeToCollectSignatureFrom: {},

    grouptTalkAcknowledgementsWithSignatures: [],

    showGroupTalkAcknowledgementsWithSignaturesModal: false,

    currentGroupAck: {},

    showRedoAckSignatureModal: false,

    isLoading: false,

    showTakeImageOfSheetModal: false,

    showSigninSheetPreviewModal: false,

    sign_off_method: '',
    theSignOffMethod: {},


    showSearchMasterAccountEmployeeListModal: false,
    employeesNotOnThisSupervisorTeamList: [],
    showAddNewEmployeeToTeamForCheckoffModal: false,

    newEmployeeFormData: {
      first_name: '',
      last_name: ''
    },

    showSelectGeneralContractorsModal: false,

    generalContractors: [],

    isSendingReport: false,


  }),


  actions: {



    fetchAllGroupTalksForThisSupervisor() {

      SupervisorDashService.getAllGroupTalksForASupervisor()
        .then((response) => {


          this.groupTalkPosts = response.data.groupTalkPosts

          // console.log(response.data)

        }).catch((err) => {

          console.log(err)

        });

    },


    fetchGroupTalkPost(uuid) {

      this.post = {}
      this.thisVideoIsYoutube = false
      this.doesPDFNameExistInLibrary = ""
      this.source1 = ""


      SupervisorDashService.getAGroupTalkForASupervisor(uuid)
        .then((response) => {

          console.log('THE API response: ', response.data)

          this.groupTalkPost = response.data.supervisorToGroupTalkPost
          this.post = response.data.supervisorToGroupTalkPost.post
          this.sign_off_method = response.data.sign_off_method

          

          //set the sign-off method
          this.setSignOffMethod()

          if (this.post.message_goal_id == 3) {

            //write a function to return if video_embed_code includes 'youtube'
            if (this.isThisVideoYoutube()) {

              this.thisVideoIsYoutube = true


            }

          }

          if (this.post.message_goal_id == 2) {


            this.doesPDFNameExistInLibrary = response.data.doesExistInLibrary

            this.buildPDFurl2()


          }


        }).catch((err) => {

          console.log(err)

        });

    },

 
    setSignOffMethod() {

      if (this.sign_off_method === 'checkoff') {

        this.theSignOffMethod = this.optionsArray[0]

        // console.log(this.theSignOffMethod)

      }

      if (this.sign_off_method === 'digital_signatures') {

        this.theSignOffMethod = this.optionsArray[1]

        // console.log(this.theSignOffMethod)

      }

      if (this.sign_off_method === 'photo_of_sheet') {

        this.theSignOffMethod = this.optionsArray[2]

        // console.log(this.theSignOffMethod)

      }

    },

    isThisVideoYoutube() {

      // Check if videoCode includes 'youtube' and return true or false
      return this.post.video_embed_code.includes('youtube');

    },


    buildPDFurl2() {

      let url = "";

      if (this.doesPDFNameExistInLibrary === 1) {

        url = "https://safelyio.nyc3.cdn.digitaloceanspaces.com/pdftalks/" + this.post.pdf_url_path;

        this.source1 = url;

        return;
      }

      if (this.doesPDFNameExistInLibrary === 0) {

        //if master_account_admin_id is null it means it was created by the master manager account
        if (this.post.master_account_admin_id == null) {

          url = "https://safelyio.nyc3.cdn.digitaloceanspaces.com/u" + this.post.manager_id + "/9j1ks/" + this.post.pdf_url_path;

        }

        //this is mean it was created by a master account admin
        if (this.post.master_account_admin_id !== null) {

          url = "https://safelyio.nyc3.cdn.digitaloceanspaces.com/u" + this.post.master_account_admin_id + "/9j1ks/" + this.post.pdf_url_path;

        }


        this.source1 = url;

        // console.log(url)
        // console.log(this.source1)

        return;
      }


    },


    triggerOpenCorrectModal(type) {

      if (type === 'checkoff') {

        this.currentMethodSelected = type
        this.fetchEmployeesForATeamForCheckoff(this.groupTalkPost.uuid)
        this.openCheckoffModal()

      }

      if (type === 'signature') {


        this.currentMethodSelected = type
        this.fetchEmployeesForATeamForSignaturesOnly()
          .then(() => {
            this.addAllEmployeesToArrayForSignatureByDefault()
            this.openEmployeesListToSelectSignaturesModal()
          })

        // this.currentMethodSelected = type
        // this.fetchEmployeesForATeamForSignaturesOnly(this.groupTalkPost.uuid)
        // this.openEmployeesListToSelectSignaturesModal()

      }

      if (type === 'signed_sheet') {

        this.currentMethodSelected = type
        this.openTakeImageOfSheetModal()


      }

    },

    openSignOffModalOption() {
      this.resetArraysForDigitalSignatures()
      this.showSignOffModalOption = true
    },

    closeSignOffModalOption() {
      this.showSignOffModalOption = false
    },

    openCheckoffModal() {
      this.showCheckoffEmployeeModal = true
    },

    closeCheckoffModal() {
      this.showCheckoffEmployeeModal = false
    },

    fetchEmployeesForATeamForCheckoff(uuid) {

      this.employees = [];
      this.employeesCheck = [];

      SupervisorDashService.getEmployeesForATeamForCheckoffOnly(uuid)
        .then((response) => {

          this.employees = response.data.employees

          //map to employeesCheck array to uncheck those not present
          this.employees.forEach(obj => {

            this.employeesCheck.push({
              user_id: obj.id,
              name: obj.name,
              checked: 1
            });

          })

          // console.log(response.data)

        }).catch((err) => {

          console.log(err)

        });

    },

    updatePresentStatus(employee) {

      //if the status id true/1 switch to false
      if (employee.checked) {

        employee.checked = 0

      } else {
        employee.checked = 1
      }


    },


    markCheckoffAsComplete() {


      this.employeeData.employeesCheck = this.employeesCheck
      this.employeeData.time_acknowledged = this.getCurrentTime()

      // console.log(this.employeeData, this.groupTalkPost.uuid)

      SupervisorDashService.markCheckoffTalkAcknowledgement(this.groupTalkPost.uuid, this.employeeData)
        .then((response) => {



          this.groupTalkPost.is_acknowledged = 1
          this.groupTalkPost.completion_type = 'checkoff'

          this.closeCheckoffModal()
          this.closeSignOffModalOption()

          toast("Talk marked as completed!", {
            position: "bottom-right",
            autoClose: 2000,
          });

          // // eslint-disable-next-line no-console
          // console.log(response.data)

        }).catch((err) => {

          // eslint-disable-next-line no-console
          console.log(err)

        });


    },

    fetchEmployeesAcknowledgementStatusForCheckoff() {

      SupervisorDashService.getCheckoffEmployeesWhoAcknowledgedAGroupTalkPost(this.groupTalkPost.uuid)
        .then((response) => {

          this.updateEmployeesCheck = response.data.employeesCheck

          // // eslint-disable-next-line no-console
          // console.log(response.data)

        }).catch((err) => {

          // eslint-disable-next-line no-console
          console.log(err)

        });

    },

    getCurrentTime() {

      return moment().format('HH:mm');

    },

    openUpdateCheckoffModal() {
      this.showUpdateCheckoffModal = true
    },

    closeUpdateCheckoffModal() {
      this.showUpdateCheckoffModal = false
    },

    updateAcknowledgementStatus() {

      this.employeeData.employeesCheck = this.updateEmployeesCheck


      SupervisorDashService.updateCheckoffGroupAcknowledgement(this.groupTalkPost.uuid, this.employeeData)
        .then((response) => {


          this.closeUpdateCheckoffModal()

          toast("Updated!", {
            position: "bottom-right",
            autoClose: 2000,
          });

          // // eslint-disable-next-line no-console
          // console.log(response.data)

        }).catch((err) => {

          // eslint-disable-next-line no-console
          console.log(err)

        });

    },


    openEmployeesListToSelectSignaturesModal() {
      this.showEmployeesListToSelectSignaturesModal = true


    },

    closeEmployeesListToSelectSignaturesModal() {

      // if (
      //   confirm(
      //     "NOTE: If you close this popup, you'll have to recapture all signatures again. Are you sure you want to close?"
      //   )
      // ) {

        //reset these only to avoid duplicate entries in employeesSelectedForSignatures
        this.employeesToCollectSignatures = []
        this.employeesSelectedForSignatures = []

        this.showEmployeesListToSelectSignaturesModal = false


      // }


    },


    fetchEmployeesForATeamForSignaturesOnly() {

      this.employeesToCollectSignatures = []

      return SupervisorDashService.getEmployeesForATeamForSignaturesOnly(this.groupTalkPost.uuid)
        .then((response) => {
          this.employeesToCollectSignatures = response.data.employees
        })
        .catch((err) => {
          console.log(err)
        })
    },


    // fetchEmployeesForATeamForSignaturesOnly() {

    //   this.employeesToCollectSignatures = []

    //   SupervisorDashService.getEmployeesForATeamForSignaturesOnly(this.groupTalkPost.uuid)
    //     .then((response) => {

    //       this.employeesToCollectSignatures = response.data.employees

    //       // console.log(response.data)

    //     }).catch((err) => {

    //       console.log(err)

    //     });

    // },
 

    addUserToSignatureArray(employee) {


      // Check if the user is already in the array
      const index = this.employeesSelectedForSignatures.findIndex(emp => emp.the_user.id === employee.id);

      if (index !== -1) {
        // If the user is already in the array, remove them
        this.employeesSelectedForSignatures.splice(index, 1);

        employee.is_checked = 0


      } else {
        // If the user is not in the array, add them

        let newobj = {
          the_user: employee,
          sign_image: null
        }

        this.employeesSelectedForSignatures.push(newobj);



        employee.is_checked = 1

      }

    },


    openListOfEmployeesToCollectSignauresFrom() {

      if (this.employeesSelectedForSignatures.length === 0) {

        alert("Please add 1 or more persons to collect signatures from.")

        return

      }

      this.showListOfEmployeesToCollectSignauresFrom = true
    },


    closeListOfEmployeesToCollectSignauresFrom() {
      this.showListOfEmployeesToCollectSignauresFrom = false
    },



    openSignatureBoxModal() {
      this.showSignatureBoxModal = true
    },

    closeSignatureBoxModal() {
      this.showSignatureBoxModal = false
    },

    setCurrentEmployeeToCollectSignatureFrom(user) {
      this.currentEmployeeToCollectSignatureFrom = user
      this.openSignatureBoxModal()
    },

    setSignatureImage(data) {

      this.currentEmployeeToCollectSignatureFrom.sign_image = data

      this.closeSignatureBoxModal()

      // console.log(this.currentEmployeeToCollectSignatureFrom, data)

    },

    redoSignauture(employee) {

      if (
        confirm(
          "Are you sure you want redo this signature?"
        )
      ) {


        this.setCurrentEmployeeToCollectSignatureFrom(employee)
        this.openSignatureBoxModal()


      }


    },

    signatureFinalSignOff() {


  

        if(!this.atleastOneSignatureMustBeCollected()){
          alert("At least one digital signature must be collected for this meeting!");
          return;
        }



        const formData = {
          employeesData: this.employeesSelectedForSignatures,
          time_acknowledged: this.getCurrentTime()
        }


        console.log(formData)

        SupervisorDashService.markSignaturesTalkAcknowledgement(this.groupTalkPost.uuid, formData)
          .then((response) => {

            this.fetchGroupTalkPost(this.groupTalkPost.uuid)

            this.closeListOfEmployeesToCollectSignauresFrom()
            this.closeEmployeesListToSelectSignaturesModal()
            this.closeSignOffModalOption()

            toast("Talk marked as completed!", {
              position: "bottom-right",
              autoClose: 2000,
            });

            this.groupTalkPost.is_acknowledged = 1
            this.groupTalkPost.completion_type = 'signature'


             // ✅ Reload the whole page
            window.location.reload()

            console.log(response.data)

          }).catch((err) => {

            console.log(err)

          });







    },


    atleastOneSignatureMustBeCollected() {
      return this.employeesSelectedForSignatures.some(
        emp => emp.sign_image && emp.sign_image.trim() !== ''
      );
    },

    hasAnyMissingSignature() {
      return this.employeesSelectedForSignatures.some(emp => emp.sign_image == null);
    },


    fetchllEmployeesWhoAlreadyHadSignaturesDoneForATalk() {

      SupervisorDashService.getAllEmployeesWhoAlreadyHadSignaturesDoneForATalk(this.groupTalkPost.uuid)
        .then((response) => {


          this.grouptTalkAcknowledgementsWithSignatures = response.data.grouptTalkacknowledgements

          // console.log(response.data)

        }).catch((err) => {

          console.log(err)

        });


    },

    openGroupTalkAcknowledgementsWithSignaturesModal() {
      this.showGroupTalkAcknowledgementsWithSignaturesModal = true
    },

    closeGroupTalkAcknowledgementsWithSignaturesModal() {
      this.showGroupTalkAcknowledgementsWithSignaturesModal = false
    },

    openFetchAckDataAndOpenModal() {

      // console.log('yes')

      this.fetchllEmployeesWhoAlreadyHadSignaturesDoneForATalk()
      this.openGroupTalkAcknowledgementsWithSignaturesModal()

    },

    redoAckSignauture(ack) {

      if (
        confirm(
          "Are you sure you want redo this signature?"
        )
      ) {


        this.setCurrentAck(ack)
        this.openRedoAckSignatureModal()


        // this.setCurrentEmployeeToCollectSignatureFrom(employee)



      }


    },

    setRedoAckSignatureImage(data) {

      this.isLoading = true

      this.currentGroupAck.new_image_file = data

      const formData = {
        ack: this.currentGroupAck
      }

      SupervisorDashService.uploadRedoSignatureImage(formData)
        .then((response) => {


          let new_url = response.data.new_img_url

          this.currentGroupAck.signature_img_url = new_url

          this.closeRedoAckSignatureModal()

          toast("Signature updated!", {
            position: "bottom-right",
            autoClose: 2000,
          });


          this.isLoading = false


          // console.log(response.data)

        }).catch((err) => {

          this.isLoading = false

          console.log(err)

        });

      // console.log(data)

    },

    setCurrentAck(ack) {
      this.currentGroupAck = ack
    },


    openRedoAckSignatureModal() {
      this.showRedoAckSignatureModal = true
    },

    closeRedoAckSignatureModal() {
      this.showRedoAckSignatureModal = false
    },



    openTakeImageOfSheetModal() {
      this.showTakeImageOfSheetModal = true
    },

    closeTakeImageOfSheetModal() {
      this.showTakeImageOfSheetModal = false
    },


    finalMarkUploadSignInSheetAsComplete(theImage) {

      this.isLoading = true

      const formData = {
        img_file: theImage,
        time_acknowledged: this.getCurrentTime()
      }

      // console.log(formData)

      SupervisorDashService.markUploadSignInSheetAsComplete(formData, this.groupTalkPost.uuid)
        .then((response) => {

          this.closeTakeImageOfSheetModal()
          this.closeSignOffModalOption()
          this.groupTalkPost.is_acknowledged = 1
          this.groupTalkPost.completion_type = 'signed_sheet'


          this.isLoading = false


          toast("Talk completed!", {
            position: "bottom-right",
            autoClose: 2000,
          });

          // console.log(response.data)

        }).catch((err) => {

          this.isLoading = false

          console.log(err)

        });

    },



    openSigninSheetPreviewModal() {
      this.showSigninSheetPreviewModal = true
    },

    closeSigninSheetPreviewModal() {
      this.showSigninSheetPreviewModal = false
    },


    downloadImageFile() {


      let downloadURL = this.groupTalkPost.sign_in_sheet_img_url;

      fetch(downloadURL)
        .then(response => response.blob())
        .then(blob => {
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = 'signin_sheet'; // Assuming theFile has a name property
          link.click();
        })
        .catch(console.error);


    },


    resetArraysForDigitalSignatures() {
      this.currentMethodSelected = ''
      this.employeesToCollectSignatures = []
      this.employeesSelectedForSignatures = []
    },


    openSearchMasterAccountEmployeeListModal() {
      this.getSupervisorFreshTeamList()
      this.showSearchMasterAccountEmployeeListModal = true
    },

    closeSearchMasterAccountEmployeeListModal() {
      this.showSearchMasterAccountEmployeeListModal = false
    },




    toggleEmployeeEmployeeForSupervisorTeam(employee) {

      //if the status id true/1 switch to false
      if (employee.is_checked) {
        employee.is_checked = 0;
      } else {
        employee.is_checked = 1;
      }

    },


    addTheSelectedEmployeesToThisSupervisorTeamCheckoffList() {

      const anyChecked = this.employeesNotOnThisSupervisorTeamList.some(emp => emp.is_checked === 1);

      if (!anyChecked) {
        alert("At least one employee must be selected");
        return;
      }


      //employees to add to this supervisro team
      let employeesToAddList = [];

      this.employeesNotOnThisSupervisorTeamList.forEach((employee) => {

        if (employee.is_checked === 1) {


          //add to employeesToAddList to send to the backend
          employeesToAddList.push({
            user_id: employee.id,
          })

        }

      })


      //send to backed to add these employees to this supervisor's team

      const formData = {
        team_id: this.groupTalkPost.team_id,
        employees: employeesToAddList
      }

      // console.log(formData)

      SupervisorDashService.addTheSelectedEmployeesToThisSupervisorTeam(formData)
        .then((response) => {

          let message = response.data.message

          if (message === 'success') {


            if (this.currentMethodSelected === 'checkoff') {

              this.employeesNotOnThisSupervisorTeamList.forEach((employee) => {

                if (employee.is_checked === 1) {

                  //add to checkoff list
                  this.employeesCheck.push({
                    user_id: employee.id,
                    name: employee.name,
                    checked: 1
                  });


                }

              })

            }


            if (this.currentMethodSelected === 'signature') {

              this.employeesNotOnThisSupervisorTeamList.forEach((employee) => {

                if (employee.is_checked === 1) {


                  this.employeesToCollectSignatures.push(employee);


                  this.employeesSelectedForSignatures.push({
                    the_user: employee,
                    sign_image: null
                  });

                  // console.log(this.employeesToCollectSignatures)



                }

              })


            }



          } else {

            alert('Failed to add new team members!')

          }


          this.closeSearchMasterAccountEmployeeListModal()


          // console.log(response.data)

        }).catch((err) => {

          console.log(err)

        });




    },


    getSupervisorFreshTeamList() {

      const formData = {
        team_id: this.groupTalkPost.team_id,
      }


      SupervisorDashService.fetchFreshListOfEmployeesNotOnASupervisorTeam(formData)
        .then((response) => {

          this.employeesNotOnThisSupervisorTeamList = [] //reset

          this.employeesNotOnThisSupervisorTeamList = response.data.employeesNotOnThisSupervisorTeamList



          // console.log(response.data)

        }).catch((err) => {

        });

    },

    openAddNewEmployeeToTeamForCheckoffModal() {

      this.newEmployeeFormData.first_name = ''
      this.newEmployeeFormData.last_name = ''

      this.showAddNewEmployeeToTeamForCheckoffModal = true
    },

    closeAddNewEmployeeToForCheckoffTeamModal() {
      this.showAddNewEmployeeToTeamForCheckoffModal = false
    },


    createNewEmployeeForCheckoff() {

      this.isLoading = true

      if (this.newEmployeeFormData.first_name === '') {

        alert('First name is required!')

        this.isLoading = false

        return;

      }

      if (this.newEmployeeFormData.last_name === '') {

        alert('Last name is required!')

        this.isLoading = false

        return;

      }



      const formData = {
        team_id: this.groupTalkPost.team_id,
        new_employee: this.newEmployeeFormData
      }


      SupervisorDashService.createNewEmployeeDuringCheckoff(formData)
        .then((response) => {

          let new_user = response.data.new_user

          if(this.currentMethodSelected === 'checkoff'){

            this.employeesCheck.push({
              user_id: new_user.id,
              name: new_user.name,
              checked: 1
            });
  
            this.isLoading = false
  
            this.closeAddNewEmployeeToForCheckoffTeamModal()

          }


          if (this.currentMethodSelected === 'signature') {

            this.employeesToCollectSignatures.push(new_user);


            this.employeesSelectedForSignatures.push({
              the_user: new_user,
              sign_image: null
            });

            new_user.is_checked = 1


            this.isLoading = false
  
            this.closeAddNewEmployeeToForCheckoffTeamModal()

          }



          // console.log(response.data)

        }).catch((err) => {

          this.isLoading = false

          console.log(err)

        });


    },



    addAllEmployeesToArrayForSignatureByDefault(){

      
      this.employeesToCollectSignatures.forEach((employee) => {

        let newobj = {
          the_user: employee,
          sign_image: null
        }

        this.employeesSelectedForSignatures.push(newobj);

        employee.is_checked = 1

      })

      // console.log('TEST')



    },


    captureMissingSignauture(ack) {

      this.setCurrentAck(ack)
      this.openRedoAckSignatureModal()


    },



    openSelectGeneralContractorsModal(){
      this.fetchAllGeneralContractors()
      this.showSelectGeneralContractorsModal = true
    },

    closeSelectGeneralContractorsModal(){
      this.showSelectGeneralContractorsModal = false
    },


    fetchAllGeneralContractors(){

      this.generalContractors = [];

      SupervisorDashService.getAllGeneralContractorsService()
        .then((response) => {

          this.generalContractors = response.data.general_contractors

          // console.log(response.data)
          
        }).catch((err) => {

          console.log(err)
          
        });



    },

    toggleGeneralContractor(gc) {

      //if the status id true/1 switch to false
      if (gc.is_checked) {
        gc.is_checked = 0;
      } else {
        gc.is_checked = 1;
      }

    },

    checkAlLeastOneGeneralContractorsSelected() {

        const hasSelected = this.generalContractors.some((gc) => gc.is_checked == 1);
    
        if (!hasSelected) {
            alert('Please select at least 1 general contractor!')
            return true; // has error
        }
    
        return false; // no error
    },

    sendGeneralContractorReport(){



      if(!this.checkAlLeastOneGeneralContractorsSelected()){


        this.isSendingReport = true;

        const formData = {
          gc_list: this.generalContractors,
          post: this.post,
          groupTalkPost: this.groupTalkPost
        }


        SupervisorDashService.testGCreportPFG(formData)
        .then((response) => {

              // // Create a blob from the response
              // const blob = new Blob([response.data], { type: 'application/pdf' });
              // const link = document.createElement('a');
              // link.href = window.URL.createObjectURL(blob);
              // link.download = 'test.pdf';
              // link.click();


              this.isSendingReport = false;

              this.closeSelectGeneralContractorsModal()
              

              toast("Report sent!", {
                position: "bottom-right",
                autoClose: 2000,
              });

            // console.log(response.data)
            
        }).catch((err) => {

          this.isSendingReport = false;


            console.log(err)
            
        });


        // SupervisorDashService.processSendingGroupTalkReportToGeneralContractorsService(formData)
        //   .then((response) => {

        //     console.log(response.data)
            
        //   }).catch((err) => {

        //     console.log(err)
            
        //   });

        // console.log(formData)

      }

    }





  },


});
